import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Accommodation() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <PageCarousel />
      <section className="section-padding">
        <div className="container">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center">
                <h1 className="section-title">Accommodation</h1>
              </div>
            </div>
          </div>

          {/* Top Informational Alert */}
          <div className="row justify-content-center mb-4">
            <div className="col-lg-10 col-md-12">
              
            </div>
          </div>

          {/* SECTION 1: Institute Hostel Accommodation */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 col-md-12">
              <div className="card shadow-sm border-0" style={{ borderLeft: '5px solid #005A9C' }}>
                <div className="card-body p-4">
                  <h3 className="card-title h4 mb-3" style={{ color: '#005A9C', fontWeight: '700' }}>
                    <i className="fa-solid fa-hotel me-2"></i>Institute Hostel Accommodation
                  </h3>
                  <p className="card-text text-muted mb-4">
                    In case hostel accommodation is required, we request you to email us with the following details:
                  </p>
                  
                  {/* Required Information List */}
                  <div className="bg-light p-3 rounded mb-4">
                    <h5 className="h6 text-uppercase fw-bold text-secondary mb-3">Information required in Email:</h5>
                    <div className="row g-2">
                      <div className="col-md-6"><strong>• Name</strong></div>
                      <div className="col-md-6"><strong>• Gender</strong></div>
                      <div className="col-md-6"><strong>• Contact No.</strong></div>
                      <div className="col-md-6"><strong>• Email ID</strong></div>
                      <div className="col-md-6"><strong>• Affiliation</strong></div>
                      <div className="col-md-6"><strong>• Paper ID</strong> <span className="text-muted font-monospace">(if any)</span></div>
                    </div>
                    <hr />
                    <p className="mb-0 text-dark">
                      <strong>• Required Dates:</strong> Please specify arrival/departure dates. 
                      <span className="badge bg-secondary ms-2">Check-in: 11:00 AM</span>
                      <span className="badge bg-secondary ms-2">Check-out: 11:00 AM (Next Day)</span>
                    </p>
                  </div>

                  {/* Pricing Callout */}
                  <div className="p-3 bg-light rounded border-start border-3 border-success d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <span className="text-uppercase fw-bold text-muted d-block small">Hostel Room Rates</span>
                      <span className="h4 fw-bold text-success">Rs. 472/-</span> 
                      <span className="text-muted small"> (including GST) per person / night</span>
                    </div>
                    <span className="badge bg-success px-3 py-2 mt-2 mt-md-0">Twin-Sharing Basis</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION 2: Outside Accommodation */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 col-md-12">
              <h3 className="h4 mb-4 text-dark" style={{ fontWeight: '700' }}>
                <i className="fa-solid fa-map-location-dot me-2 text-danger"></i>Outside Accommodation
              </h3>
              <p className="text-muted mb-4">
                In case you plan to make your own arrangements, the following options can be explored. These choices are situated within a <strong>5 km radius</strong> of the LNMIIT campus:
              </p>

              {/* Grid of Resorts/Hotels */}
              <div className="row g-4 mb-4">
                {/* Resort 1 */}
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="card-title fw-bold text-primary mb-2">1. Kanota Camp Resort</h5>
                      <p className="card-text small text-muted mb-3">
                        <strong>Address:</strong> New, Sumel, Beermalpura at Mukandpura, Jaipur, Rajasthan 302031
                      </p>
                      <div className="small border-top pt-2">
                        <div><strong>Email:</strong> <a href="mailto:kanotacamp@gmail.com">kanotacamp@gmail.com</a></div>
                        <div><strong>Contact:</strong> 07849836982, 07849836981</div>
                        <div><strong>Contact Person:</strong> Manohar Singh</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Resort 2 */}
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="card-title fw-bold text-primary mb-2">2. Hill Side Resort</h5>
                      <p className="card-text small text-muted mb-3">
                        <strong>Address:</strong> Opposite Sumel Doongri, Keshav Vidhya Peeth L.N. Mittal Road, Jamdoli, Jaipur, Rajasthan 302031
                      </p>
                      <div className="small border-top pt-2">
                        <div><strong>Contact Details:</strong> 099290 43703</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Resort 3 */}
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="card-title fw-bold text-primary mb-2">3. Vinayak Resort</h5>
                      <span className="badge bg-warning text-dark mb-2">Low Budget Option</span>
                      <p className="card-text small text-muted mb-3">
                        <strong>Address:</strong> Madhav Nagar, Near Keshav Vidhya Peeth, Jamdoli, Jaipur, Rajasthan (302031)
                      </p>
                      <div className="small border-top pt-2">
                        <div><strong>Contact:</strong> 9549803424</div>
                        <div><strong>Contact Person:</strong> Surya Pratap Singh</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* City Stay & Transit Note */}
              <div className="p-3 bg-light rounded border border-start-0 text-muted small">
                <i className="fa-solid fa-circle-info me-2 text-info"></i>
                In case you plan to stay in Jaipur city, multiple hotel options are available online. 
                <strong> Raja Park</strong> and nearby areas will be highly suitable if you wish to avail the Institute bus services to-and-from the city. 
                Please note that LNMIIT is located around <strong>14 kms</strong> away from the main city center.
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default Accommodation;